import React from "react";

import Header from './components/Header'
import Causes from './components/Causes'

function App() {
  return (
    <div className="App">
      <Header />
      <Causes />
    </div>
  );
}

export default App;
